import classnames from "classnames";
import PropTypes from "prop-types";
import styles from "./label.module.scss";
import ClearancePricing from "./clearance-pricing";
import { useSelector } from "react-redux";
import { isActiveMembership } from "helpers/membership-helpers";
import MoleculePrice from "./molecule-price";
import { showDecimal } from "helpers/price-helper";

export function getRetailPricingLabel(isExclusiveDesign) {
  return isExclusiveDesign ? "Comparable Value" : "Original Retail";
}

function determinePricingMode(isClearance, isActiveSubscriber) {
  if (isClearance) {
    return "SHOW_CLEARANCE_PRICE";
  } else if (isActiveSubscriber) {
    // show comparable value price, Buy (KIF) Price
    return "SHOW_BUY_AND_MSRP_PRICE";
  } else {
    // show comparable value price
    return "SHOW_MSRP_PRICE";
  }
}

const Label = ({ product }) => {
  const {
    buyPrice,
    clearanceDiscount,
    currencyCode = "USD",
    designerDisplayName,
    displayName,
    exclusiveDesign,
  } = product;
  // This approach is overly simple (i.e. clearance vs non-clearance) but we can
  // evolve this area over time as different grid types emerge.
  const isClearance = useSelector(state => state.nextGridType === "clearance");
  const membershipState = useSelector(state => state.membershipState);
  const isActiveSubscriber = isActiveMembership(membershipState);
  // Note: clearance grids use `product.msrp` (which is returned by the clearance endpoint), whereas
  // other endpoints like those that power curation grids return a complex object `product.price`
  return (
    <div className={classnames(styles.label)}>
      <div className={classnames(styles.label__wrapper)}>
        <p className={classnames(styles.label__title)}>{designerDisplayName}</p>
        <p className={classnames(styles.label__subtitle)}>{displayName}</p>
        {
          {
            SHOW_CLEARANCE_PRICE: (
              <>
                <ClearancePricing
                  amount={buyPrice}
                  comparableAmount={product.msrp}
                  comparableText={getRetailPricingLabel(exclusiveDesign)}
                  currencyCode={currencyCode}
                  discount={clearanceDiscount}
                  showDecimal={showDecimal(buyPrice)}
                />
              </>
            ),
            SHOW_MSRP_PRICE: (
              <MoleculePrice
                priceTitle={getRetailPricingLabel(exclusiveDesign)}
                className={classnames(styles.label__prices)}
                amount={product.price?.find(el => el?.id === "msrp")?.value}
                currencyCode={currencyCode}
                showDecimal={showDecimal(product.price?.find(el => el?.id === "msrp")?.value)}
              />
            ),
            SHOW_BUY_AND_MSRP_PRICE: (
              <>
                <MoleculePrice
                  priceTitle="Buy"
                  className={classnames(styles.label__buy_price)}
                  amount={product.price?.find(el => el?.id === "buy")?.value}
                  currencyCode={currencyCode}
                  showDecimal={showDecimal(product.price?.find(el => el?.id === "buy")?.value)}
                />
                <MoleculePrice
                  priceTitle={getRetailPricingLabel(exclusiveDesign)}
                  className={classnames(styles.label__prices)}
                  amount={product.price?.find(el => el?.id === "msrp")?.value}
                  currencyCode={currencyCode}
                  showDecimal={showDecimal(product.price?.find(el => el?.id === "msrp")?.value)}
                />
              </>
            ),
          }[determinePricingMode(isClearance, isActiveSubscriber)]
        }
      </div>
    </div>
  );
};

Label.propTypes = {
  product: PropTypes.object,
};

export default Label;
